import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  IncentivesWizardEntities,
  IncentivesWizardModel,
  IncentivesWizardPaths,
} from 'client/data/models/incentives-wizard';
import { getPageTransactionType } from 'site-modules/shared/components/incentives/incentives-wizard/utils/get-page-transaction-type';
import { maybe, wrapInArray } from 'site-modules/shared/utils/incentives/gql-incentives-filter';

function WithInitialWizardIncentivesUI({
  attributes,
  inventoryType,
  paymentType,
  children,
  initialIncentives = undefined,
  setModelValue,
}) {
  const makeSlug = get(attributes, 'vehicle.make.niceId', '');
  const modelSlug = get(attributes, 'vehicle.model.niceId', '');
  const year = get(attributes, 'vehicle.modelYear.year', '');

  useEffect(() => {
    setModelValue(IncentivesWizardPaths.getInitialIncentivesWizardData(), IncentivesWizardModel, {
      makeSlug,
      modelSlug,
      engineTypes: ['electric', 'plug-in hybrid'],
      transactionType: getPageTransactionType(inventoryType, paymentType),
      inventoryCode: inventoryType.toUpperCase(),
      years: maybe(year).map(wrapInArray).unpack(),
    });
  }, [inventoryType, makeSlug, modelSlug, paymentType, setModelValue, year]);

  return children(initialIncentives);
}

WithInitialWizardIncentivesUI.propTypes = {
  attributes: PropTypes.shape({
    vehicle: PropTypes.shape({
      make: PropTypes.shape({ niceId: PropTypes.string }),
      model: PropTypes.shape({ niceId: PropTypes.string }),
      modelYear: PropTypes.shape({ year: PropTypes.number }),
    }),
  }).isRequired,
  inventoryType: PropTypes.string.isRequired,
  paymentType: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  initialIncentives: IncentivesWizardEntities.IncentivesData,
  setModelValue: PropTypes.func.isRequired,
};

export const WithInitialWizardIncentives = connectToModel(WithInitialWizardIncentivesUI, {
  initialIncentives: bindToPath(
    IncentivesWizardPaths.getInitialIncentivesWizardData(),
    IncentivesWizardModel,
    null,
    false
  ),
});
